import { MultiselectCategoryListViewImpl } from '../../login/createaccountcomponent/categorylist/multiselectcategorylistview';
import { BaseContext } from '../../../../utils/basecontext';
import { PreferenceCategoryListViewModelImpl } from './preferenccard/preferencecategorylistviewmodel';

export class PreferenceCategoryListViewImpl extends MultiselectCategoryListViewImpl
{
    protected getViewModel(applicationContext: BaseContext)
    {
       return new PreferenceCategoryListViewModelImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/myaccount/preferences/preferencecategorylistview.tsx